import { MealPlan, ScaledRecipe } from '@/api/types'
import { Grid } from '@/components/Grid'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import MealDivisionTypeBadge from './MealDivisionTypeBadge'
import { getNutrientsForUser, getRecipesSumQuantity } from '../utils'

function ScaledRecipeRow({
  scaledRecipe,
  mainUserId,
}: {
  scaledRecipe: ScaledRecipe
  mainUserId: number
}) {
  const { t } = useTranslation()
  const getRecipeOrIngredientName = (scaledRecipe: ScaledRecipe) => {
    if (scaledRecipe.recipe) {
      return scaledRecipe.recipe.name
    }

    if (
      scaledRecipe.mealOfDayDivision.type === 'INGREDIENT' &&
      scaledRecipe.scaledRecipeIngredients &&
      scaledRecipe.scaledRecipeIngredients.length > 0
    ) {
      return scaledRecipe.scaledRecipeIngredients[0].ingredient.name
    }
    return 'Unknown'
  }

  const nutri = useMemo(
    () => getNutrientsForUser([scaledRecipe], mainUserId),
    [scaledRecipe, mainUserId],
  )

  return (
    <>
      <div style={{ textAlign: 'left', display: 'flex', gap: '5px' }}>
        {getRecipeOrIngredientName(scaledRecipe)}{' '}
        <MealDivisionTypeBadge mealDivision={scaledRecipe.mealOfDayDivision} />
      </div>
      <div>{Math.round(nutri.energy)}</div>
    </>
  )
}

export default function DayMealPlanCard({
  dayPlan,
  mainUserId,
}: {
  dayPlan: MealPlan
  mainUserId: number
}) {
  const { t } = useTranslation()

  const dailyNutri = useMemo(
    () => getNutrientsForUser(dayPlan.scaledRecipes, mainUserId),
    [dayPlan, mainUserId],
  )

  return (
    <>
      <Grid columns="7fr 1fr" style={{ width: '100%' }}>
        <h4 style={{ textAlign: 'left' }}>{t(`mealOfDay.${dayPlan.mealOfDay}` as any)}</h4>
        <div>Kcal</div>

        {dayPlan.scaledRecipes.map((rec, i) => (
          <ScaledRecipeRow key={i} scaledRecipe={rec} mainUserId={mainUserId} />
        ))}
      </Grid>
      <Grid
        columns="1fr 1fr 5fr 1fr"
        style={{
          width: '100%',
          marginTop: '20px',
          paddingTop: '10px',
          borderTop: '1px solid var(--gray-200)',
        }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
          <div>Protein</div>
          <div>{Math.round(dailyNutri.protein)}</div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
          <div>Carbs</div>
          <div>{Math.round(dailyNutri.carbohydrate)}</div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
          <div>Fat</div>
          <div>{Math.round(dailyNutri.fat)}</div>
        </div>
        <div>{Math.round(dailyNutri.energy)}</div>
      </Grid>
    </>
  )
}
